export default {
  name: 'about', // do not change
  pageTitle: 'About',
  icon: 'mdi-account',

  greeting: 'Hello, I am Massimo Schembri.',
  description: 'I\'m a very curious guy, especially when we are talking about IT things or games. Actually I am working very hard in the field of containers and automation, GitOps methodologies and kubernetes as the driver for my learning and working.',
  birthYear: '1996',
  residence: 'Italy',
  freelance: 'Unavailable',
  address: 'Bologna, IT',
  quote: 'If there is a solution to a problem, there is no need to worry. And if there is no solution, there is no need to worry',
  hobbies: [
    {
      title: 'Personal Finance',
      icon: 'mdi-finance',
      description: 'Is a very cool topic and money management is very important!'
    },
    {
      title: 'Cooking',
      icon: 'mdi-chef-hat',
      description: 'Being able to make something good/new to eat for my friends and me makes me very happy!'
    }
  ]
};
